import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-lib-fw-header-wrapper',
  templateUrl: './header-wrapper.component.html',
  styleUrls: ['./header-wrapper.component.scss'],
})
export class FormlyHeaderWrapperComponent extends FieldWrapper {}
